import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const Wrapper = styled(Box)``;

export const StyledLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
